export const CORINGAS = [
  {
    name: "Coringa 1",
    id: "00000000-0000-0000-0000-000000000001",
  },
  {
    name: "Coringa 2",
    id: "00000000-0000-0000-0000-000000000002",
  },
  {
    name: "Coringa 3",
    id: "00000000-0000-0000-0000-000000000003",
  },
];

export const CORINGA_IDS = new Set(CORINGAS.map((coringa) => String(coringa.id)));

export const isCoringaId = (playerId) => CORINGA_IDS.has(String(playerId || ""));
